<template>
  <div class="con">
    <div class="con_title">{{ title }}</div>
    <div class="con_list clearfix">
      <div class="text-list" v-for="(item, index) in powerList" :key="index">
        <div class="left">
          <img class="icon" :src="item.iconUrl" />
          <span class="text">{{ item.name }}</span>
        </div>
        <div class="right">
          <div class="text1">{{ item.toWho }}</div>
          <div class="text2" v-for="(subitem, subindex) in item.descList" :key="subindex">{{ subitem }}</div>
          <!-- <a class="link" :href="item.url"> -->
          <div class="link" @click="dialogShow">
            <span>{{ item.link }}</span>
            <div class="icon"></div>
          </div>
          <!-- </a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: {
    title: String,
    powerList: Array,
  },
  computed: {
    ...mapState('semTest', ['uuidInfo']),
  },
  data() {
    return {
      openSwitch: 0,
    }
  },
  methods: {
    dialogShow() {
      // abTest埋点，三屏灵活产品与能力【免费试用】点击
      this.$tsignData.track('sempc_thirdpage_test_click', {
        uuid: this.uuidInfo, // 用户唯一标识
      })
      // thirdpage,表示网页三屏的入口
      this.$emit('showDialog', 'thirdpage')
    },
  },
}
</script>

<style lang="less" scoped>
.con {
  height: 726px;
  background-color: #fcfcfc;
  padding: 60px 0 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  background: #fcfcfc;
  .con_title {
    font-size: 36px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 50px;
    margin-bottom: 30px;
  }
  .clearfix:after {
    content: '';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }
  .con_list {
    width: 1200px;
    .text-list {
      min-width: 582px;
      height: 264px;
      padding: 30px 10px;
      float: left;
      display: flex;
      align-items: flex-start;
      &:hover {
        background: #ffffff;
        box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
      }
      .left {
        display: flex;
        flex-direction: column;
        margin-right: 38px;
        .icon {
          display: inline-block;
          width: 220px;
          height: 150px;
        }
        .text {
          text-align: center;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          line-height: 28px;
          margin-top: 20px;
        }
      }
      .right {
        margin-top: -10px;
        .text1 {
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #333333;
          line-height: 25px;
          margin-bottom: 11px;
        }
        .text2 {
          position: relative;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 28px;
          padding-left: 13px;
          &::before {
            content: ' ';
            position: absolute;
            display: block;
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #e61717;
            left: 0;
            top: 12px;
          }
        }
      }
      .link {
        display: flex;
        align-items: center;
        // justify-content: center;
        padding-left: 13px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #e61717;
        line-height: 20px;
        margin-top: 8px;
        cursor: pointer;
        .icon {
          width: 39px;
          height: 20px;
          background: url('../../../../assets/images/goIn.gif');
          background-size: contain;
          background-repeat: no-repeat;
        }
      }
    }
  }
}
</style>
